import { ADD_ARTICLE, SET_FLAGS } from "../constants/action-types";
export const addArticle = article => ({ type: ADD_ARTICLE, payload: article });
export const setFlags = flags => ({ type: SET_FLAGS, payload: flags });



// WEBPACK FOOTER //
// ./src/redux/actions/index.js